import { jsx as _jsx } from "react/jsx-runtime";
export default function Divider({ children }) {
    return _jsx("span", { className: "react-date-picker__inputGroup__divider", children: children });
}
